import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import CategoryPage from './pages/CategoryPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage'; // Import CheckoutPage
import OrderConfirmation from './pages/OrderConfirmation';
import AdminOrders from './pages/AdminOrders';
import AdminPayments from './pages/AdminPayments';
import AdminLogin from './pages/AdminLogin';
import PolicyPage from './pages/PolicyPage';
import { ToastProvider } from './components/ToastProvider';
import ScrollProgressButton from './components/ScrollProgressButton';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

import { CustomerAuthProvider } from './contexts/CustomerAuthContext';
import CustomerLogin from './pages/CustomerLogin';
import AccountLayout from './pages/account/AccountLayout';
import Profile from './pages/account/Profile';
import Orders from './pages/account/Orders';
import OrderDetail from './pages/account/OrderDetail';
import Addresses from './pages/account/Addresses';
import ProtectedCustomerRoute from './components/ProtectedCustomerRoute';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastProvider>
        <CustomerAuthProvider>
          <Routes>
            {/* Public layout - Header and Footer visible */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} /> {/* New Route */}
              <Route path="/order-confirmation" element={<OrderConfirmation />} />


              {/* Policy pages */}
              <Route
                path="/privacy-policy"
                element={(
                  <PolicyPage
                    title="Privacy Policy"
                    filePath="/policies/privacy-policy.md"
                  />
                )}
              />
              <Route
                path="/terms-and-conditions"
                element={(
                  <PolicyPage
                    title="Terms & Conditions"
                    filePath="/policies/terms-and-conditions.md"
                  />
                )}
              />
              <Route
                path="/refund-and-returns"
                element={(
                  <PolicyPage
                    title="Refund & Returns Policy"
                    filePath="/policies/refund-and-returns-policy.md"
                  />
                )}
              />
              <Route
                path="/shipping-policy"
                element={(
                  <PolicyPage
                    title="Shipping Policy"
                    filePath="/policies/shipping-policy.md"
                  />
                )}
              />
              <Route path="/contact" element={<div style={{ padding: '100px', textAlign: 'center' }}>Contact Us Page Coming Soon</div>} />

              {/* Customer Auth */}
              <Route path="/login" element={<CustomerLogin />} />
              <Route
                path="/account"
                element={
                  <ProtectedCustomerRoute>
                    <AccountLayout />
                  </ProtectedCustomerRoute>
                }
              >
                <Route index element={<Profile />} />
                <Route path="orders" element={<Orders />} />
                <Route path="orders/:orderId" element={<OrderDetail />} />
                <Route path="addresses" element={<Addresses />} />
              </Route>
            </Route>

            {/* Admin routes - NO header/footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/payments" element={<AdminPayments />} />
          </Routes>
          <ScrollProgressButton />
        </CustomerAuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;

